<template>
  <div>
    <div class="row">
      <!-- Stats Cards -->
      <div class="col-lg-3 col-md-6" v-for="(card, index) in statsCards" :key="index">
        <stats-card
          :title="card.title"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
        >
          <div slot="footer" v-html="card.footer"></div>
        </stats-card>
      </div>
    </div>
  </div>
</template>
<script>
  import CountryMapCard from './CountryMapCard';
  import StatsCard from 'src/components/Cards/StatsCard';
  import {DashboardService} from '@/services';

  export default {
    components: {
      StatsCard,
      CountryMapCard,
    },
    data() {
      return {
        dashboardData: {},
        statsCards: [],
        regions: []
      };
    },
    methods: {
      initStatsCards() {
        this.statsCards = [
          {
            title: this.dashboardData.totalApplicants.toString(),
            subTitle: 'Registered Users',
            type: 'info',
            icon: 'tim-icons icon-single-02',
            footer: '***'
          }
        ]
      },
      initCountryMap() {

      },
      initDashboard() {
        let vm = this;
        DashboardService.getDashboardData().then(function (response) {
          vm.dashboardData = response.data;
          vm.initStatsCards()
          vm.initCountryMap();
        })
      },
    },
    mounted() {

    },
    beforeMount() {
      this.initDashboard();
    },
    beforeDestroy() {
    }
  };
</script>
<style></style>
